<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
  <div class="w-full max-w-md rounded-lg bg-white p-6 shadow-xl" (click)="$event.stopPropagation()">
    <div class="mb-6 flex items-start justify-between">
      <h2 class="text-lg text-gray-900" i18n="@@confirmationCancel">
        Are you sure you want to cancel? Your comments will be lost.
      </h2>
      <button (click)="onCloseModal()" class="cursor-pointer rounded border p-1 text-gray-500 hover:text-gray-700">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="flex justify-end gap-3">
      <button
        (click)="onCloseModal()"
        class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-4 py-2 text-[12px] font-[500] hover:cursor-pointer">
        <span i18n="@@no">NO</span>
      </button>
      <button
        (click)="onSubmit()"
        i18n="@@yes"
        class="bg-primary hover-bg-primary-hover rounded-[6px] px-4 py-2 text-[12px] font-[500] text-white hover:cursor-pointer disabled:cursor-not-allowed">
        YES
      </button>
    </div>
  </div>
</div>
